import { render, staticRenderFns } from "./WeekdayHourMatrixChart.vue?vue&type=template&id=5e6e7567&"
import script from "./WeekdayHourMatrixChart.vue?vue&type=script&lang=js&"
export * from "./WeekdayHourMatrixChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e6e7567')) {
      api.createRecord('5e6e7567', component.options)
    } else {
      api.reload('5e6e7567', component.options)
    }
    module.hot.accept("./WeekdayHourMatrixChart.vue?vue&type=template&id=5e6e7567&", function () {
      api.rerender('5e6e7567', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/Dashboard/WeekdayHourMatrixChart.vue"
export default component.exports